export default __webpack_public_path__ + "static/media/bf_fox_not_found.4b8329c2.png";